import * as React from 'react'


interface ISystemList {
    className: string,
    to: string,
    children: any,
    title: string
}

export const SystemList = (props: ISystemList) => {
    return (
        <li className={props.className} >{props.children}</li>
    )
}
